import Header from "../../components/header";
import Sidebar from "../../components/sidebar";
import Chat from "../../components/chat";
import HeaderSearch from "../../components/header-search";
import {Outlet, Route, Routes as ReactRoutes} from "react-router-dom";
import Footer from "../../components/footer";
import Modals from "../modals";
import React from "react";
import Homepage from "../homepage";
import Settings from "../settings";
import SportsBook from "../sportsbook/index";
import ESport from "../e-sport/index";
import flattenDeep from 'lodash/flattenDeep';
import ProtectedRoute from "../../hooks/protected-route";
import NotFound from "../modals/not-found";
import Vip from "../vip";
import Transactions from "../transactions";
import PlayGame from "../play-game";
import Favorites from "../favorites";
import Policy from "../policy";
import License from "../license";
import Tickets from "../tickets";
import Poker from "../poker";
import RaceDetail from "../race-detail";
import RaffleDetail from "../raffle-detail";
import Slots from "../slots";
import Casino from "../casino";
import Promotions from "../promotions";
import Blog from "../blog";
import HelpCenter from "../help-center";
import CasinoGroup from "../casino-group";
import Affiliate from "../affiliate";
import Providers from "../providers";
import ProviderDetail from "../providers-detail";
import CasinoCategory from "../casino-category";
import LiveCasinoPage from "../live-casino";
import LowBar from "../../components/lowbar/index";
import ExclusiveGamesPage from "../exclusive-games";
import PlayMobile from "../play-game/mobile/play-mobile";
import Trade from "../trade";
import Tournaments from "../tournaments";
import TournamentDetail from "../tournament-detail";
import EmailVerified from "../email-verified";
import VirtualSports from "../virtual-sports";
import BlogDetail from "../blog/detail";
import PromotionDetail from "../promotions/detail";
import TelegramAuth from "../telegram-auth";
import Streams from "../streams";
import ConversionAuth from "../conversion-auth";
import Challenges from "../challenges";
import Stream from "../stream";
import WheelHomepage from "../modals/wheel/wheel";

const MainLayout = () => {

    return (
        // <div className={'l-app container--fluid'} id={'content-root'}>
        <>

            <div className="body" id="body">


                <Sidebar/>

                <main className="main" id="main">
                    <Header/>
                    <HeaderSearch/>
                    <div className="main__content" id="main__content">
                        <Outlet/>
                        <Footer/>
                    </div>
                </main>

                <Chat/>

            </div>

            <LowBar/>
            <Modals/>
        </>

        // </div>
    )
}
const languages = [
    'en',
    'tr',
    'fr',
    'ru',
    'az',
    'es',
    'de',
    'pl',
    'ch',
    'kr',
    'ar',
    'it',
    'pt',
    'id',
    'in',
    'be',
    'jp',
    'vi',
    'in'

]
export const routes = [
    {
        layout: MainLayout,
        routes: [
            {
                component: Homepage,
                path: '/',
                isPublic: true
            },
            ...languages.map(lang => ({
                component: Homepage,
                path: `/${lang}/`, // Language-prefixed homepage
                isPublic: true,
            })),
            {
                component: Slots,
                path: 'casino/slots',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: Slots,
                path: `/${lang}/casino/slots/`, // Language-prefixed homepage
                isPublic: true,
            })),
            {
                component: EmailVerified,
                path: 'email-verified/:token',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: EmailVerified,
                path: `/${lang}/email-verified/:token/`, // Language-prefixed homepage
                isPublic: true,
            })),

            {
                component: TelegramAuth,
                path: 'tg/auth/:token',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: TelegramAuth,
                path: `/${lang}/tg/auth/:token/`, // Language-prefixed homepage
                isPublic: true,
            })),


            {
                component: ConversionAuth,
                path: 'conversion/auth/:secret',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: ConversionAuth,
                path: `/${lang}/conversion/auth/:secret/`, // Language-prefixed homepage
                isPublic: true,
            })),

            {
                component: Casino,
                path: '/casino',
                isPublic: true,
            },

            ...languages.map(lang => ({
                component: Casino,
                path: `/${lang}/casino/`, // Language-prefixed homepage
                isPublic: true,
            })),
            {
                component: PlayGame,
                path: 'casino/games/:slug',
                isPublic: true
            },
            ...languages.map(lang => ({
                component: PlayGame,
                path: `/${lang}/casino/games/:slug/`, // Language-prefixed homepage
                isPublic: true,
            })),

            {
                component: PlayMobile,
                path: 'casino/games/:slug/play',
                isPublic: true,
                isFull: true
            },
            ...languages.map(lang => ({
                component: PlayMobile,
                path: `/${lang}/casino/games/:slug/play/`, // Language-prefixed homepage
                isPublic: true,
            })),

            {
                component: LiveCasinoPage,
                path: 'live-casino',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: LiveCasinoPage,
                path: `/${lang}/live-casino/`, // Language-prefixed homepage
                isPublic: true,
            })),
            {
                component: Providers,
                path: 'providers',
                isPublic: true,
            },

            ...languages.map(lang => ({
                component: Providers,
                path: `/${lang}/providers/`, // Language-prefixed homepage
                isPublic: true,
            })),
            {
                component: ProviderDetail,
                path: 'providers/:slug',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: ProviderDetail,
                path: `/${lang}/providers/:slug/`, // Language-prefixed homepage
                isPublic: true,
            })),
            {
                component: CasinoGroup,
                path: 'casino/group/:type',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: CasinoGroup,
                path: `/${lang}/casino/group/:type/`, // Language-prefixed homepage
                isPublic: true,
            })),
            {
                component: VirtualSports,
                path: 'casino/virtual_sports',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: VirtualSports,
                path: `/${lang}/casino/virtual_sports/`, // Language-prefixed homepage
                isPublic: true,
            })),
            {
                component: ExclusiveGamesPage,
                path: 'casino/category/exclusive',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: ExclusiveGamesPage,
                path: `/${lang}/casino/category/exclusive/`, // Language-prefixed homepage
                isPublic: true,
            })),
            {
                component: CasinoCategory,
                path: 'casino/category/:type',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: CasinoCategory,
                path: `/${lang}/casino/category/:type/`, // Language-prefixed homepage
                isPublic: true,
            })),

            {
                component: Challenges,
                path: 'challenges',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: Challenges,
                path: `/${lang}/challenges/`, // Language-prefixed homepage
                isPublic: true,
            })),


            {
                component: Streams,
                path: 'streams',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: Streams,
                path: `/${lang}/streams/`, // Language-prefixed homepage
                isPublic: true,
            })),


            {
                component: Stream,
                path: '/stream/:id',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: Stream,
                path: `/${lang}/stream/:id`, // Language-prefixed homepage
                isPublic: true,
            })),


            {
                component: HelpCenter,
                path: 'help',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: HelpCenter,
                path: `/${lang}/help/`, // Language-prefixed homepage
                isPublic: true,
            })),
            {
                component: Affiliate,
                path: 'affiliate',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: Affiliate,
                path: `/${lang}/affiliate/`, // Language-prefixed homepage
                isPublic: true,
            })),
            {
                component: Promotions,
                path: 'promotions',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: Promotions,
                path: `/${lang}/promotions/`, // Language-prefixed homepage
                isPublic: true,
            })),
            {
                component: Blog,
                path: 'blog',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: Blog,
                path: `/${lang}/blog/`, // Language-prefixed homepage
                isPublic: true,
            })),

            {
                component: WheelHomepage,
                path: 'wheel',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: WheelHomepage,
                path: `/${lang}/wheel/`, // Language-prefixed homepage
                isPublic: true,
            })),

            {
                component: PromotionDetail,
                path: 'promotion/:slug',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: PromotionDetail,
                path: `/${lang}/promotion/:slug/`, // Language-prefixed homepage
                isPublic: true,
            })),
            {
                component: BlogDetail,
                path: 'blog/:slug',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: BlogDetail,
                path: `/${lang}/blog/:slug/`, // Language-prefixed homepage
                isPublic: true,
            })),
            {
                component: RaceDetail,
                path: 'race/detail/:uuid',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: RaceDetail,
                path: `/${lang}/race/detail/:uuid/`, // Language-prefixed homepage
                isPublic: true,
            })),
            {
                component: RaffleDetail,
                path: 'raffle/detail/:uuid',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: RaffleDetail,
                path: `/${lang}/raffle/detail/:uuid/`, // Language-prefixed homepage
                isPublic: true,
            })),
            {
                component: Poker,
                path: 'poker',
                isPublic: false,
            },
            ...languages.map(lang => ({
                component: Poker,
                path: `/${lang}/poker/`, // Language-prefixed homepage
                isPublic: true,
            })),


            // {
            //     component: SportsBook,
            //     path: 'sportsbook/*',
            //     isPublic: true,
            // },
            // ...languages.map(lang => ({
            //     component: SportsBook,
            //     path: `/${lang}/sportsbook/*`, // Language-prefixed homepage
            //     isPublic: true,
            // })),

            {
                component: SportsBook,
                path: 'sportsbook',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: SportsBook,
                path: `/${lang}/sportsbook/`, // Language-prefixed homepage
                isPublic: true,
            })),

            {
                component: SportsBook,
                path: 'sportsbook/:type/*',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: SportsBook,
                path: `/${lang}/sportsbook/:type/*`, // Language-prefixed homepage
                isPublic: true,
            })),


            {
                component: ESport,
                path: 'e-sport',
                isPublic: true,
            },
            ...languages.map(lang => ({
                component: ESport,
                path: `/${lang}/e-sport/`, // Language-prefixed homepage
                isPublic: true,
            })),


            {
                component: Favorites,
                path: 'favorites',
                isPublic: false,
            },

            ...languages.map(lang => ({
                component: Favorites,
                path: `/${lang}/favorites/`, // Language-prefixed homepage
                isPublic: true,
            })),
            {
                component: Settings,
                path: 'settings',
                isPublic: false
            },
            ...languages.map(lang => ({
                component: Settings,
                path: `/${lang}/settings/`, // Language-prefixed homepage
                isPublic: true,
            })),

            {
                component: Trade,
                path: 'trade',
                isPublic: true
            },
            ...languages.map(lang => ({
                component: Trade,
                path: `/${lang}/trade/`, // Language-prefixed homepage
                isPublic: true,
            })),

            {
                component: Vip,
                path: '/vip',
                isPublic: true
            },
            ...languages.map(lang => ({
                component: Vip,
                path: `/${lang}/vip/`, // Language-prefixed homepage
                isPublic: true,
            })),
            {
                component: Transactions,
                path: '/transactions',
                isPublic: false
            },

            ...languages.map(lang => ({
                component: Transactions,
                path: `/${lang}/transactions/`, // Language-prefixed homepage
                isPublic: true,
            })),
            {
                component: Policy,
                path: '/policy',
                isPublic: true
            },
            ...languages.map(lang => ({
                component: Policy,
                path: `/${lang}/policy/`, // Language-prefixed homepage
                isPublic: true,
            })),
            // {
            //     component: License,
            //     path: '/license',
            //     isPublic: true
            // },
            // ...languages.map(lang => ({
            //     component: License,
            //     path: `/${lang}/license/`, // Language-prefixed homepage
            //     isPublic: true,
            // })),

            {
                component: Tournaments,
                path: '/tournaments',
                isPublic: true
            },
            ...languages.map(lang => ({
                component: Tournaments,
                path: `/${lang}/tournaments/`, // Language-prefixed homepage
                isPublic: true,
            })),

            {
                component: TournamentDetail,
                path: '/tournament/:uuid',
                isPublic: true
            },
            ...languages.map(lang => ({
                component: TournamentDetail,
                path: `/${lang}/tournament/:uuid/`, // Language-prefixed homepage
                isPublic: true,
            })),
            {
                component: Tickets,
                path: '/raffle/:key/tickets',
                isPublic: false
            },

            ...languages.map(lang => ({
                component: Tickets,
                path: `/${lang}/raffle/:key/tickets/`, // Language-prefixed homepage
                isPublic: true,
            })),
            {
                component: NotFound,
                path: '*',
                isPublic: true
            },
            ...languages.map(lang => ({
                component: NotFound,
                path: `/${lang}/*/`, // Language-prefixed homepage
                isPublic: true,
            })),
        ]
    }
];

const generateFlattenRoutes = (routes) => {
    if (!routes) return [];
    return flattenDeep(routes.map(({routes: subRoutes, ...rest}) => [rest, generateFlattenRoutes(subRoutes)]));
}


export const renderRoutes = (mainRoutes) => {
    return () => {
        const layouts = mainRoutes.map(({layout: Layout, routes, component: Component, path, isPublic}, index) => {
            if (Layout) {
                // For routes with a layout
                const subRoutes = generateFlattenRoutes(routes);
                return (
                    <Route key={index} element={<Layout/>}>
                        {subRoutes.map(({component: Component, path, isPublic}) => {
                            return <Route key={path}
                                          element={
                                              <ProtectedRoute isPublic={isPublic}>
                                                  <Component/>
                                              </ProtectedRoute>
                                          }
                                          path={path}/>
                        })}
                    </Route>
                );
            } else {
                // For routes without a layout (like Page403)
                return (
                    <Route key={path} path={path} element={
                        <ProtectedRoute isPublic={isPublic}>
                            <Component/>
                        </ProtectedRoute>
                    }/>
                );
            }
        });

        return <ReactRoutes>{layouts}</ReactRoutes>;
    };
}
export const Routes = renderRoutes(routes);
